import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getPartnerSpecificApps } from '@atlassian/mpac-api-client';
import { DateUtils, log } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
import { useAsync } from 'react-async';
import { PAGINATION_LIMIT } from "../../../../constants/Preferences";

const transformPartnerAppsData = partnerApps => {
  const transformedPartnerApps = partnerApps._embedded.addons.map(app => ({
    name: app.name,
    key: app.key,
    manageAppUrl: "/manage/apps/".concat(app.id),
    visibility: app.status,
    lastUpdated: app._embedded.lastModified ? DateUtils.ISOFormatHyphenatedDate(new Date(app._embedded.lastModified)) : '',
    loyaltyDiscountOptIn: app._embedded.loyaltyDiscountEnabled
  }));

  return {
    count: partnerApps.count,
    apps: transformedPartnerApps
  };
};

export const usePartnerApps = (mpacBaseUrl, partnerId, offset, searchQuery) => {
  const queryParams = _objectSpread({
    offset,
    limit: PAGINATION_LIMIT,
    includeHidden: 'all',
    includePrivate: true,
    withPricingInfo: true
  }, searchQuery && {
    text: searchQuery
  });

  const promiseFn = useCallback(_ => getPartnerSpecificApps(mpacBaseUrl, partnerId, queryParams).then(data => transformPartnerAppsData(data)).catch(_error => _error), [offset, partnerId, searchQuery]);
  const {
    data,
    error,
    isPending
  } = useAsync({
    promiseFn
  });

  if (error) {
    log.error('usePartnerApps', "Failed to retrieve Vendor Apps List", {
      error
    });
  }

  return {
    pending: isPending,
    error,
    partnerApps: data
  };
};